import React, { useState, useEffect } from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '../Appointments/Appointments.css';
import './Settings.css';
import Sidebar from '../Sidebar';
import InternalHeader from '../InternalHeader';
import { useNavigate } from 'react-router-dom';
import AccessControl from '../AccessControl';


const Settings = () => {
    const [isSidebarVisible, setIsSidebarVisible] = useState(true);


    const navigate = useNavigate();

    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
    };


    return (
        <AccessControl>
            <div className={`settings-page ${isSidebarVisible ? 'sidebar-open' : 'sidebar-closed'}`}>
                <InternalHeader moduleName="Settings" toggleSidebar={toggleSidebar} />
                <div className="appointments-container">
                    <Sidebar isSidebarVisible={isSidebarVisible} />
                    <div className="settings-container">
                        <div>
                            <button className="settings-button">Save</button>
                            <div>
                                <div className="settings-header">
                                    <h2>Appointments</h2>
                                </div>
                                <div className="settings-input-field">
                                    <label>Patients per day</label>
                                    <p>Set a default daily limit of patients for all dates.</p>
                                    <input
                                        type="text"
                                        name="chiefComplaint"
                                        className="settings-input"
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="settings-header">
                                    <h2>Patients</h2>
                                </div>
                                <div className="settings-input-field">
                                    <div className="flex-div">
                                        <input
                                            type="checkbox"
                                            className="settings-checkbox-field"
                                        />
                                        <div>
                                            <label>Enable birthday notifictions</label>
                                            <p>Set a default daily limit of patients for all dates.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="settings-header">
                                    <h2>Inventory</h2>
                                </div>
                                <div className="settings-input-field">
                                    <label>Restock Alert</label>
                                    <p>Specify the amount of dental supplies before an alert is sent.</p>
                                    <input
                                        type="text"
                                        name="chiefComplaint"
                                        className="settings-input"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AccessControl>
    );
};

export default Settings;